import { CustomSnackbar } from 'components';
import * as ReactDOM from 'react-dom';
import { ThemeProvider as ThemeProviderCore } from '@material-ui/core/styles';
import { ThemeProvider as ThemeProviderMui } from '@mui/material/styles';
import { theme, themeMui } from './AppThemeProvider';

let snackbarExisted = false;

export function renderSnackbar(
  text: Array<string>,
  actionLabel?: string,
  actionClick?: () => void,
  className?: string,
  autoHide?: boolean
) {
  const sNew = document.createElement('div');
  document.getElementsByTagName('body')[0].appendChild(sNew);
  ReactDOM.render(
    <ThemeProviderCore theme={theme}>
      <ThemeProviderMui theme={themeMui}>
        <CustomSnackbar
          onClose={() => {
            sNew.remove();
            snackbarExisted = false;
          }}
          text={text}
          onClick={() => {
            if (actionClick) {
              actionClick();
              return;
            }

            sNew.remove();
            snackbarExisted = false;
          }}
          actionLabel={actionLabel}
          className={className}
          autoHide={autoHide}
        />
      </ThemeProviderMui>
    </ThemeProviderCore>,
    sNew
  );
}
